
import img1 from "../../../assets/client/client-1.png";
import img2 from "../../../assets/client/client-2.png";
import img3 from "../../../assets/client/client-3.png";
import img4 from "../../../assets/client/client-4.png";
import img5 from "../../../assets/client/client-5.png";

const TeamData = [
    {
        id:1,
        img:img1,
        name: "Nicholas Donarski",
        tesimony:"I am amazed to see the quality of work that Techqilla did for me. Awesome Designers and awesome team.",
        title: "Founder"
    },{
        id:2,
        img:img2,
        name: "Jonah Havel",
        tesimony:"It's a  very professional company that leaves no requirement and opinion pending. The staff is also very friendly and innovative.",
        title: "Software Developer and Military Operation"
    },{
        id:3,
        img:img5,
        name: "Carl G Morris",
        tesimony:"Wonderful communication, rapid response, excellent listner,detailed oriented, great suggestions, exercise foresight, goal oriented, time conscious having your best  interest in mind",
        title: "CEO (Envision Travel Group)"
    },{
        id:4,
        img:img3,
        name: "Shawn Piatz",
        tesimony:"Techqilla was fantastic to work  with! Diksha, Vishesh, Sakshi and the whole staff are creative, Intelligent people who helped us meet  our need and expand our audience on social media.",
        title: "VPO"
    },{
        id:5,
        img:img4,
        name: "Lucas Hamrick",
        tesimony:"Honestly I am so satisfied with thier work after wandering companies  to companies I finally found the perfect partner that provides great strategies for my business",
        title: "Chief Executive Office"
    }

]

export default TeamData;